
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type fitmentTableTabMobileRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableTabMobileRT(): TemplateResult<fitmentTableTabMobileRTRootProps> {
    return this.vehicleSpecific || this.manyFitments ? _createElement('h2', {
        'className': 'mb-0',
        'key': '0'
    }, _createElement('button', {
        'className': 'btn btn-link btn-block text-left collapsed',
        'type': 'button',
        'data-toggle': 'collapse',
        'data-target': '#product-accordion-collapse-fitment-table',
        'aria-expanded': 'true',
        'aria-controls': 'product-accordion-collapse-fitment-table'
    }, '\n    Fitment\n  ')) : null;
}
        export const componentNames = []